import React from 'react';

import WidgetNumber from './WidgetNumber';

import BookprocessWidgetProps from './interfaces/BookprocessWidgetPropsInterface';
import PropsNumber from './interfaces/PropsNumberInterface';

export default class WidgetNumberWithButtons extends WidgetNumber {
    addButtons(props: BookprocessWidgetProps, ele: React.ReactElement<PropsNumber>) {
        const modifyInputValue = function (modify: number) {
            let newval: string | number;
            newval = (parseInt(props.getStateValue(props.name), 10) || 0) + modify;
            if (props.disabled) {
                return;
            }
            let max = Number(props.max);
            if (newval > max) {
                newval = max;
            }
            let min = Number(props.min);
            if (newval < min) {
                newval = modify > 0 ? min : ''; // When clicking -1 on the minimum value, make it empty
            }
            props.handleChange(props.name, newval.toString());
        };

        const clickMinus = function (event: React.MouseEvent<HTMLInputElement>) {
            modifyInputValue(-1);
            event.preventDefault();
        };

        const clickPlus = function (event: React.MouseEvent<HTMLInputElement>) {
            modifyInputValue(1);
            event.preventDefault();
        };

        return React.createElement(
            'div',
            { className: 'numberWithPlusMinus' },
            ele,
            React.createElement(
                'button',
                {
                    onClick: clickMinus,
                    type: 'button',
                },
                '-'
            ),
            React.createElement(
                'button',
                {
                    onClick: clickPlus,
                    type: 'button',
                },
                '+'
            )
        );
    }

    render() {
        let numberele = React.createElement(WidgetNumber, this.props as PropsNumber);
        return this.addButtons(this.props, numberele);
    }
}
